import { ISeasonResortLiftTickets } from 'api/resort/types';
import { IGridColumn } from 'components/common/Grid/types';
import { I18nKey } from 'i18n/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatDateFromStr } from 'util/formatDate';
import { ticketsTypes, TicketsTypesEnum } from './constants';

import styles from './styles.module.scss';

export const generateSeasonsGridColumns = (seasonLiftTickets: ISeasonResortLiftTickets) => {
  const { t } = useOTSTranslation('common');

  const defaultColumns: IGridColumn[] = [{
    header: {
      cellRender: () => (<>{t('resort.liftTickets.validSeason')}</>),
      className: styles.transparentCell,
    },
    dataKey: 'season',
    cellRender: (data: ISeasonResortLiftTickets) => (
      <span>
        <span>
          <span>{`${t('resort.liftTickets.validSeason')} `}</span>
          <span>{data.season}</span>
        </span>
        <span>{`${t('resort.liftTickets.expirationDate')} ${formatDateFromStr(data.expires || undefined, 'DD')}`}</span>
      </span>
    ),
    className: styles.seasonTitleCell,
  }];

  const columns = ticketsTypes.reduce((acc, curr) => {
    const priceKey = `${curr}Price` as keyof ISeasonResortLiftTickets;
    const ageKey = `${curr}Age` as keyof ISeasonResortLiftTickets;
    let columnTitle: string = curr;

    if (curr === TicketsTypesEnum.children) { columnTitle = 'child'; }
    if (curr === TicketsTypesEnum.teenager) { columnTitle = 'junior'; }

    if (seasonLiftTickets[priceKey]) {
      acc.push({
        header: {
          cellRender: () => (
            <span>
              <span>{t(`resort.liftTickets.${columnTitle}` as I18nKey['common'])}</span>
              <span>
                {/* https://github.com/i18next/react-i18next/issues/1700 */}
                {/* @ts-ignore */}
                {seasonLiftTickets[ageKey]
                  ? seasonLiftTickets[ageKey]
                  : ''}
              </span>
            </span>
          ),
          className: styles.header,
        },
        dataKey: priceKey,
      });
    }

    return acc;
  }, defaultColumns);

  return columns;
};
